import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';
import {
  GET_MASS_EMAILS,
  ADD_MASS_EMAIL,
  DELETE_MASS_EMAIL,
  EDIT_MASS_EMAIL,
  UPDATE_MASS_EMAIL,
  SEND_MASS_EMAIL,
} from './actionTypes';
import {
  setMassEmails,
  emptyMassEmail,
  setMassEmail,
  apiError,
  getMassEmails as fetchMassEmails,
  setMassEmailFilter
} from './actions';
import { httpDelete, httpGet, httpPost, httpPut } from '../../utils/http';
import { MASS_EMAILS_ENDPOINT } from '../../config/endPoints';
import { successToaster, errorToaster } from "../../components/Common/Toaster";

function* getMassEmails() {
  try {
    const massEmailState = yield select(getMassEmail);
    let URL = MASS_EMAILS_ENDPOINT;
    URL += `?offSet=${massEmailState.filter.offSet}`;
    URL += `&limit=${massEmailState.filter.limit}`;
    URL += `&query=${massEmailState.filter.query}`;

    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setMassEmails(res.data.records));
    yield put(
      setMassEmailFilter({
        field: 'pages',
        value: res.data.pages,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* addMassEmail({payload: {history}}) {
  try {
    const massEmailState = yield select(getMassEmail);
    const massEmail = massEmailState.massEmail;
    const res = yield httpPost(MASS_EMAILS_ENDPOINT, massEmail);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(emptyMassEmail());
    history.push('/massEmails/list');
    successToaster('Record added.', 'Success');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* deleteMassEmail({ payload: { id, history } }) {
  try {
    const res = yield httpDelete(`${MASS_EMAILS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }
    console.log('shoud run');
    yield put(fetchMassEmails());
  } catch (error) {
    yield put(apiError(error));
  }
}

function* editMassEmail({ payload: { id } }) {
  try {
    const res = yield httpGet(`${MASS_EMAILS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(
      setMassEmail({ field: 'email_name', value: res.data.email_name })
    );
    yield put(setMassEmail({ field: 'from_name', value: res.data.from_name }));
    yield put(setMassEmail({ field: 'content', value: res.data.content }));
    yield put(
      setMassEmail({ field: 'from_email', value: res.data.from_email })
    );
    yield put(setMassEmail({ field: 'subject', value: res.data.subject }));
    yield put(
      setMassEmail({ field: 'hourly_total', value: res.data.hourly_total })
    );
    
    let arr = [];
    if(res.data.user_type && res.data.user_type.length > 0){
      for(let i = 0; i < res.data.user_type.length; i++){
        arr = [...arr, {label: res.data.user_type[i], value: res.data.user_type[i]}];
      }
    }

    if(arr.length > 0){
      console.log('arr redux', arr);
      yield put(setMassEmail({ field: 'user_type', value: arr }));
    }

  } catch (error) {
    yield put(apiError(error));
  }
}

function* updateMassEmail({ payload: { id, history } }) {
  try {
    const massEmailState = yield select(getMassEmail);
    const massEmail = massEmailState.massEmail;
    const res = yield httpPut(`${MASS_EMAILS_ENDPOINT}/${id}`, massEmail);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    history.push('/massEmails/list');
    successToaster('Record updated.', 'Success');

  } catch (error) {
    yield put(apiError(error));
  }
}

function* sendMassEmail({ payload: { id } }) {
  try {
    const res = yield httpGet(`${MASS_EMAILS_ENDPOINT}/send/${id}`);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    successToaster('Mass email has been sent.', 'Success');

  } catch (error) {
    yield put(apiError(error));
  }
}

const getMassEmail = (state) => state.MassEmail;

export function* watchGetMassEmails() {
  yield takeEvery(GET_MASS_EMAILS, getMassEmails);
}

export function* watchAddMassEmail() {
  yield takeEvery(ADD_MASS_EMAIL, addMassEmail);
}

export function* watchDeleteMassEmail() {
  yield takeEvery(DELETE_MASS_EMAIL, deleteMassEmail);
}

export function* watchEditMassEmail() {
  yield takeEvery(EDIT_MASS_EMAIL, editMassEmail);
}

export function* watchUpdateMassEmail() {
  yield takeEvery(UPDATE_MASS_EMAIL, updateMassEmail);
}

export function* watchSendMassEmail() {
  yield takeEvery(SEND_MASS_EMAIL, sendMassEmail);
}


function* massEmailSaga() {
  yield all([
    fork(watchGetMassEmails),
    fork(watchAddMassEmail),
    fork(watchDeleteMassEmail),
    fork(watchEditMassEmail),
    fork(watchUpdateMassEmail),
    fork(watchSendMassEmail)
  ]);
}

export default massEmailSaga;
